module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/stacked_desktop1-fe1c4250a7c0b4d019dea47396aa2e21.jpg";